import { tv } from 'tailwind-variants'

export const slotDateButtonStyles = tv({
	slots: {
		slotButtonContainer: 'w-16 border-palette_8 border-b-2',
		slotDayOfWeek:
			'w-full py-2.5 font-apercu-primary text-center bg-[#007F6F] text-md text-palette_2',
		slotDateDay: 'w-full text-center text-palette_3 text-lg pt-2',
		slotDateMonth: 'w-full text-center text-palette_3 text-md pb-2',
	},
})
